<template>
	<intersect @enter="startCountdown()" @leave="stopCountdown()" v-if="timeLeft > 0">
		<div class="countdown">{{ countdown }} <a @click="cancelCountdown">{{cancel}}</a></div>
	</intersect>
</template>

<script>
import Intersect from "vue-intersect"

export default {
	components: { Intersect },
	data() {
		return {
            timerInterval: null,
			timeLeft: 30,
		};
    },
    computed: {
        countdown() {
            return (this.message || '#').replace('#', this.timeLeft)
        },
    },
    props: {
        message: String,
        cancel: String,
	},
    methods: {
        cancelCountdown: function() {
            window.sessionStorage.setItem(this.message, true)
            clearInterval(this.timerInterval)
            this.timeLeft = 0
        },
        startCountdown: function() {
            if (window.sessionStorage.getItem(this.message)) {
                this.timeLeft = 0
                return
            } 
            this.timeLeft = 30
            this.timerInterval = setInterval(() => {
                this.timeLeft -= 1
                if (this.timeLeft == 0) {
                    clearInterval(this.timerInterval)
                    this.$emit('action')
                }
            }, 1000)
        },
        stopCountdown() {
            clearInterval(this.timerInterval)
        }
    }
}
</script>
<style scoped lang="less">
@import url('~whitebox-presentation/src/assets/variables.less');
.countdown {
    color: @gray-50;
    a {
        text-decoration: underline;
        color: purple;
        cursor: pointer;
        &:hover {
            color: @magenta;
        }
    }
}
</style>
